import { BaseFeatureItemDto } from '../../base/dtos/base-feature-item.dto';
import { VehicleFeatureItemTypeEnum } from '../enums/vehicle-feature-item-type.enum';

/**
 * Vehicle feature item DTO
 */
export class VehicleFeatureItemDto extends BaseFeatureItemDto {
	type!: VehicleFeatureItemTypeEnum;
}
